import { UiVariable } from 'pages/AutomationEngine/dialogs/VariableWizard/types';

import { ActionStep } from './subsections/actionSectionTypes';
import { modifyRelatedEntitiesRemoveVariable } from './subsections/ModifyRelatedEntities/modifyRelatedEntitiesRemoveVariable';
import { changeFieldValueRemoveVariable } from './subsections/ChangeFieldValue/changeFieldValueRemoveVariable';

export const checkVariableUsedInActions = (
  steps: ActionStep[],
  variable: UiVariable
) => {
  const variableName = variable.details.variable.name;

  return steps.some((step) => {
    switch (step.type) {
      case 'modify_related_entities':
        return step.details.fieldsToModify.some((fieldToModify) => {
          return (
            fieldToModify.valueType?.value === 'variable' &&
            fieldToModify.variable?.value === variableName
          );
        });

      case 'change_field_value':
        return (
          step.details.changeType?.value === 'variable' &&
          step.details.variable?.value === variableName
        );

      default:
        return false;
    }
  });
};

export const removeDeletedVariableFromActions = (
  steps: ActionStep[],
  variable: UiVariable
) => {
  const variableName = variable.details.variable.name;
  const errorIds: string[] = [];

  if (variable && steps.length) {
    const nextSteps = steps.map((step) => {
      if (step.type === 'modify_related_entities') {
        const { nextStep, nextErrorIds } = modifyRelatedEntitiesRemoveVariable(
          step,
          variableName,
          errorIds
        );

        errorIds.push(...nextErrorIds);

        return nextStep;
      }

      if (step.type === 'change_field_value') {
        const { nextStep, nextErrorIds } = changeFieldValueRemoveVariable(
          step,
          variableName,
          errorIds
        );

        errorIds.push(...nextErrorIds);

        return nextStep;
      }

      return step;
    });

    return { nextSteps, errorIds };
  }

  return { nextSteps: steps, errorIds };
};
